import { baseClient } from "./baseRequest";
import { CalendarEvent, DateTime } from "./calendarEvent";
import { Klydo } from "./klydo";

export type PersonalFeedHistoryResponse = {
  calendarEvent: CalendarEvent;
  displayedKlydos: {
    klydo: Klydo;
    clockIds: string[];
  }[];
};

export type PersonalFeedHistory = CalendarEvent & {
  displayedKlydos: {
    klydo: Klydo;
    clockIds: string[];
  }[];
};

export type PersonalFeedHistoryInput = {
  skip: number;
  limit: number;
  date?: DateTime;
};

export type PersonalFeedApiClient = {
  getPersonalFeedHistory: ({
    skip,
    limit,
    date,
  }: PersonalFeedHistoryInput) => Promise<PersonalFeedHistoryResponse[]>;
};

const personalFeedApiClient: PersonalFeedApiClient = {
  getPersonalFeedHistory: async ({
    skip,
    limit,
    date,
  }: PersonalFeedHistoryInput) => {
    let url = `/admin/personal-feed/history/?skip=${skip}&limit=${limit}`;
    if (date) {
      url += `&date[year]=${date.year}&date[month]=${date.month}&date[day]=${date.day}`;
    }

    return baseClient.get<PersonalFeedHistoryResponse[]>({
      url,
    });
  },
};

export default personalFeedApiClient;
